import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'
import store from '../store'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Companies from '../views/Companies/Companies.vue'
//import NewCompany from "../views/Companies/NewCompany.vue";
import CompanyForm from '../views/Companies/CompanyForm.vue'
import Patients from '../views/Patients/Patients.vue'
//import NewPatient from "../views/Patients/NewPatient.vue";
import PatientForm from '../views/Patients/PatientForm.vue'
import PatientCalendar from '../views/Patients/PatientCalendar.vue'
import ShopForm from '../views/Shops/ShopForm.vue'
import Shops from '../views/Shops/Shops.vue'
import Orders from '../views/Orders/Orders.vue'
import CopyOrder from '../views/Orders/CopyOrder.vue'
import SimplifiedCopyOrder from '../views/Orders/SimplifiedCopyOrder.vue'
import ClaimForm from '../views/Orders/ClaimForm.vue'
import Claim from '../views/Orders/Claim.vue'
import ResponsetoClaimForm from '../views/Orders/ResponseForm.vue'
import Material from '../views/Materials/Materials.vue'
import MaterialForm from '../views/Materials/MaterialForm.vue'
import Mod from '../views/Mod/Mods.vue'
import ModForm from '../views/Mod/ModForm.vue'
import Shapes from '../views/Shapes/Shapes.vue'
import ShapeForm from '../views/Shapes/ShapeForm.vue'
import Users from '../views/Users/Users.vue'
import UserForm from '../views/Users/UserForm.vue'
import Forbidden from '../views/Errors/Forbidden.vue'
import Translations from '../views/Translations/Translations.vue'
import TranslationsMaterial from '../views/Translations/TranslationsMaterial.vue'
import Catalogs from '../views/Catalogs/Catalogs.vue'
//import InternalCatalogs from "../views/Catalogs/InternalCatalogs.vue";
import CatalogForm from '../views/Catalogs/CatalogForm.vue'
import WebCatalog from '../views/Catalogs/WebCatalog.vue'
import OrderFormDynamic from '@/views/Orders/OrderFormDynamic.vue'
import Soles from '@/views/Soles/Soles.vue'
import SoleForm from '@/views/Soles/SoleForm.vue'
import Allestimenti from '@/views/Allestimenti/Allestimenti.vue'
import AllestimentiForm from '@/views/Allestimenti/AllestimentiForm.vue'
/*import ModFormFits from '@/views/Mod/ModFormFits.vue'*/

Vue.use(Router)

export const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/companies',
      name: 'companies',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: Companies,
      //import(/* webpackChunkName: "about" */ "./views/Companies.vue")
    },
    {
      path: '/companies/new',
      name: 'newCompany',
      component: CompanyForm,
    },
    {
      path: '/companies/edit/:id',
      name: 'editCompany',
      component: CompanyForm,
      props: true,
    },
    {
      path: '/shops',
      name: 'shops',
      component: Shops,
    },
    {
      path: '/shops/new',
      name: 'newShop',
      component: ShopForm,
    },
    {
      path: '/shops/edit/:id',
      name: 'editShop',
      component: ShopForm,
      props: true,
    },
    {
      path: '/patients',
      name: 'patients',
      component: Patients,
    },
    {
      path: '/patients/new',
      name: 'newPatient',
      component: PatientForm,
    },
    {
      path: '/patients/edit/:id',
      name: 'editPatient',
      component: PatientForm,
      props: true,
    },
    {
      path: '/patients/calendar/:id',
      name: 'Calendar',
      component: PatientCalendar,
      props: true,
    },
    {
      path: '/orders',
      name: 'orders',
      component: Orders,
    },
    {
      path: '/orders/new',
      name: 'newOrder',
      component: OrderFormDynamic,
      props: true,
    },
    {
      path: '/orders/edit/:module/:orderId',
      name: 'editOrder',
      component: OrderFormDynamic,
      props: true,
    },
    {
      path: '/orders/copy/:orderIdToCopy',
      name: 'copyOrder',
      component: CopyOrder,
      props: true,
    },
    {
      path: '/orders/copy/:orderIdToCopy',
      name: 'simplifiedCopyOrder',
      component: SimplifiedCopyOrder,
      props: true,
    },
    {
      path: '/orders/newClaim',
      name: 'newClaim',
      component: ClaimForm,
      props: true,
    },
    {
      path: '/orders/editClaim',
      name: 'editClaim',
      component: ClaimForm,
      props: true,
    },
    {
      path: '/orders/Claim',
      name: 'Claim',
      component: Claim,
      props: true,
    },

    {
      path: '/orders/newResponse',
      name: 'newResponsetoClaim',
      component: ResponsetoClaimForm,
    },
    {
      path: '/materials/:module',
      name: 'materials',
      component: Material,
      props: true,
    },
    {
      path: '/materials/:module/new',
      name: 'newMaterial',
      component: MaterialForm,
      props: true,
    },
    {
      path: '/materials/:module/:id/edit',
      name: 'editMaterial',
      component: MaterialForm,
      props: true,
    },
    {
      path: '/allestimenti/:module',
      name: 'allestimenti',
      component: Allestimenti,
      props: true,
    },
    {
      path: '/allestimenti/:module/new/:id',
      name: 'newAllestimento',
      component: AllestimentiForm,
      props: true,
    },
    {
      path: '/allestimenti/:module/edit/:id',
      name: 'editAllestimento',
      component: AllestimentiForm,
      props: true,
    },
    {
      path: '/models/:module',
      name: 'mods',
      component: Mod,
      props: true,
    },
    {
      path: '/models/:module/new',
      name: 'newMod',
      component: ModForm,
      props: true,
    },
    {
      path: '/models/:module/edit/:id',
      name: 'editMod',
      component: ModForm,
      props: true,
    },
    {
      path: '/shapes/:module',
      name: 'shapes',
      component: Shapes,
      props: true,
    },
    {
      path: '/shapes/:module/new',
      name: 'newShape',
      component: ShapeForm,
      props: true,
    },
    {
      path: '/shapes/:module/edit/:id',
      name: 'editShape',
      component: ShapeForm,
      props: true,
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
    },
    {
      path: '/users/new',
      name: 'newUser',
      component: UserForm,
    },
    {
      path: '/users/edit',
      name: 'editUser',
      component: UserForm,
    },
    {
      path: '/forbidden',
      name: 'forbidden',
      component: Forbidden,
    },
    {
      path: '/translations',
      name: 'translations',
      component: Translations,
    },
    {
      path: '/translationsmaterial',
      name: 'translationsMaterial',
      component: TranslationsMaterial,
    },
    {
      path: '/catalogs',
      name: 'catalogs',
      component: Catalogs,
    },
    {
      path: '/catalogs/:module/new',
      name: 'newCatalog',
      component: CatalogForm,
      props: true,
    },
    {
      path: '/catalogs/:module/edit/:id',
      name: 'editCatalog',
      component: CatalogForm,
      props: true,
    },
    {
      path: '/catalogs/webcatalog',
      name: 'webcatalog',
      component: WebCatalog,
      props: true,
    },
    {
      path: '/soles/:module',
      name: 'soles',
      component: Soles,
      props: true,
    },
    {
      path: '/soles/:module/new',
      name: 'newSole',
      component: SoleForm,
      props: true,
    },
    {
      path: '/soles/:module/edit/:id',
      name: 'editSole',
      component: SoleForm,
      props: true,
    },
  ],
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/', '/login']
  //let authRequired = true
  const authRequired = !publicPages.includes(to.path)
  //get User Info and redirect if needed
  firebase.auth().onAuthStateChanged(async user => {
    if (user) {
      if (store.getters.user.email != user.email) {
        const usersDocs = await firebase
          .firestore()
          .collection('users')
          .where('email', '==', user.email)
          .get()
        usersDocs.forEach(userDoc => {
          const user = userDoc.data()
          store.commit('setUserMainInfo', user)
          store.dispatch('selectLanguage', user.language)
        })
        const infoDocs = await firebase
          .firestore()
          .collection('usersInfo')
          .where('email', '==', user.email)
          .get()
        infoDocs.forEach(infoDoc => {
          const userInfo = {
            ...infoDoc.data(),
            id: infoDoc.id,
          }
          store.commit('setUserAdditionalInfo', userInfo)
        })
      }
    }
    //routing
    if (!authRequired) {
      next()
      return
    }
    if (!user) {
      next('/login')
      return
    }
    next()
  })

  //firebase.auth().onAuthStateChanged(function(user) {
  //if (user) {
  //if (store.getters.user.email != user.email) {
  //firebase
  //.firestore()
  //.collection('users')
  //.where('email', '==', user.email)
  //.get()
  //.then(docs => {
  //docs.forEach(doc => {
  //let userMainInfo = {}
  //userMainInfo.email = doc.data().email
  //userMainInfo.language = doc.data().language
  //store.commit('setUserMainInfo', userMainInfo)
  //firebase
  //.firestore()
  //.collection('usersInfo')
  //.where('email', '==', user.email)
  //.get()
  //.then(docs => {
  //docs.forEach(doc => {
  //let userInfo = doc.data()
  //userInfo.id = doc.id
  //store.commit('setUserAdditionalInfo', userInfo)
  //next()
  //})
  //})
  //})
  //})
  //} else {
  //next()
  //}
  //} else {
  //if (!authRequired) {
  //next()
  //} else {
  //next('/login')
  //}
  //}
  //})
})
